import { React } from '@gasbuddy/react';
import { Segment } from 'semantic-ui-react';
import { VerticalCenter } from '../../components/vertical-center';
// Currently the unauthorized "page" is just the component
export { Unauthorized } from '../../components/auth';

export const Unknown = () => (
  <VerticalCenter>
    <Segment textAlign="center" raised>
      <h1>Route not yet implemented</h1>
    </Segment>
  </VerticalCenter>
);
